import React from 'react';
import { Alert, Empty, List, Typography } from 'antd';
import type { PursuitAttentionItem } from './pursuitWorkspaceModel';

const { Text } = Typography;

export type PursuitAttentionPanelProps = {
  items: PursuitAttentionItem[];
  onItemClick?: (item: PursuitAttentionItem) => void;
};

export const PursuitAttentionPanel: React.FC<PursuitAttentionPanelProps> = ({
  items,
  onItemClick,
}) => {
  if (!items.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Nothing needs attention right now."
      />
    );
  }

  return (
    <List
      size="small"
      dataSource={items}
      renderItem={(item) => (
        <List.Item
          style={{ cursor: onItemClick ? 'pointer' : undefined }}
          onClick={() => onItemClick?.(item)}
        >
          <Alert
            style={{ width: '100%' }}
            type={
              item.severity === 'critical'
                ? 'error'
                : item.severity === 'warning'
                  ? 'warning'
                  : 'info'
            }
            showIcon
            message={item.title}
            description={item.detail ? <Text type="secondary">{item.detail}</Text> : undefined}
          />
        </List.Item>
      )}
    />
  );
};

export default PursuitAttentionPanel;
